import { FunctionComponent, ReactNode, useState } from "react";
import styled from "styled-components";
import { Spacer } from "./Spacer";
import { TextCapitalized } from "./text/TextCapitalized";
import { typographies } from "../../styles/figmaTypographies";
import { colors } from "../../styles/figmaColors";
import { ExpandMoreIconOutlined } from "../materialUi/materialUi";

interface CollapseDSProps {
  label: string;
  children: ReactNode;
}

export const CollapseDS: FunctionComponent<CollapseDSProps> = (props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <StyledContainer>
      <StyledHeader onClick={() => setIsExpanded(!isExpanded)}>
        <TextCapitalized>{props.label}</TextCapitalized>
        <Spacer x={0.25} />
        <StyledIcon $expanded={isExpanded}>
          <ExpandMoreIconOutlined />
        </StyledIcon>
      </StyledHeader>
      <StyledCollapse $expanded={isExpanded}>
        <StyledCollapseInner>
          <Spacer y={0.5} />
          {props.children}
        </StyledCollapseInner>
      </StyledCollapse>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledHeader = styled.div`
  ${typographies["Body/M"]}
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${colors["colors/system/success/success_normal"]};
  width: fit-content;
`;

const StyledIcon = styled.div<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  transition: transform 0.2s ease;
  transform: rotate(${({ $expanded }) => ($expanded ? "180deg" : "0deg")});
  & svg {
    width: 1rem;
    height: 1rem;
    fill: ${colors["colors/system/success/success_normal"]};
  }
`;

const StyledCollapse = styled.div<{ $expanded: boolean }>`
  display: grid;
  grid-template-rows: ${({ $expanded }) => ($expanded ? "1fr" : "0fr")};
  transition: grid-template-rows 0.2s ease;
`;

const StyledCollapseInner = styled.div`
  overflow: hidden;
`;
